import React from "react";

const ExpandArrow = ({ colour = "white", isFilled }) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isFilled ? (
        <path
          d="M8.05681 0H1.94319C1.12982 0 0.656693 0.91937 1.12946 1.58124L4.18627 5.86077C4.58509 6.41912 5.41491 6.41912 5.81373 5.86077L8.87054 1.58124C9.34331 0.91937 8.87018 0 8.05681 0Z"
          fill={colour}
        />
      ) : (
        <path
          d="M1 1L6 7L11 1"
          stroke={colour}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export default ExpandArrow;
